
export enum SalesListingSortBy {
  price= 'price',
  km= 'km',
  firstRegistrationYear= 'firstRegistrationYear',
  startAt= 'startAt',
  createdAt= 'createdAt',
  priority= 'priority',

}